import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';
// Шрифты первыми: объявления @font-face должны быть известны до того,
// как браузер начнёт раскладывать текст.
import './fonts.css';
// Затем Tailwind (переменные темы и утилиты), затем рукописный CSS:
// он должен побеждать в спорных местах.
import './tailwind.css';
import './styles.css';
import './nocturne.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Не найден корневой элемент #root');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service worker делает сайт устанавливаемым приложением.
// В разработке он только мешает: кэш перекрывал бы горячую перезагрузку.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}
